import React from 'react';
import { FormDelegate } from '../utils';

class Input extends React.Component {

    componentDidMount() {
        this.registerWithDelegate();
    }

    registerWithDelegate() {
        if (this.props.delegate instanceof FormDelegate) {
            this.unregisterDelegate = this.props.delegate.registerInput(this);
        }
    }

    componentWillUnmount() {
        if (this.unregisterDelegate) {
            this.unregisterDelegate();
        }
    }

    get validators() {
        let validatorList = this.props.validators || [];
        if (this.props.validators && !Array.isArray(this.props.validators)) {
            validatorList = [this.props.validators];
        }

        return validatorList;
    }

    get value() {
        return (this.refs.inputElement) ? this.refs.inputElement.value : '';
    }

    setValue(val) {
        if (this.refs.inputElement) {
            this.refs.inputElement.value = val;
        }
    }

    isValid(value) {
        value = value || this.getValue();
        let validatorList = this.validators;

        return validatorList.every((validator) => {
            return validator(value);
        });
    }

    typeFilter(value) {
        switch (this.props.type.toLowerCase()) {
            case 'text':
                return value + '';
            case 'tel':
                return Number(value);
            default:
                return value;
        }
    }

    changeHandler(event) {
        if (this.props.delegate instanceof FormDelegate) {
            this.props.delegate.updateInput(this);
        }

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(event);
        }
    }

    render () {
        let className = this.props.className || '';

        return (
            <input {...this.props} ref="inputElement" onChange={e => this.changeHandler(e)} className={'component-input ' + className} />
        )
    }
}

export default Input;



// WEBPACK FOOTER //
// ./web-app/components/input.jsx